<!--答案解析-->
<template>
  <div class="uni-question-analysis">
    <div class="answer-box active">
      <div class="p1">
        <div style="flex: 1">
          <div class="scorePoints" v-if="analysisDatas.question_style === 5">
            <!--            <div class="score" v-if="totalScore">此题得分：{{ totalScore }}分</div>-->
            <div class="scorePointsList" v-if="analysisDatas.score_points">
              <h3>得分点详情</h3>
              <ul>
                <li
                  v-for="(item, index) in JSON.parse(
                    analysisDatas.score_points
                  )"
                  :key="index"
                >
                  <el-row :gutter="20">
                    <el-col :span="22">
                      <div class="scoreCenter">
                        <p><em></em></p>
                        {{ item.text }} ({{ item.fraction }}分)
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <p class="scoreDf">
                        得{{ item.hasScored ? item.hasScored : 0 }}分
                      </p>
                    </el-col>
                  </el-row>
                </li>
              </ul>
            </div>
          </div>

          <p v-show="analysisDatas.question_style !== 5">
            参考答案： <span class="yes">{{ analysisDatas | getCorrect }}</span>
          </p>
        </div>

        <p>
          <span class="opera" @click="correctVisible = !correctVisible">
            <i class="iconfont iconcuotiku mar5"></i>纠错
          </span>
        </p>
      </div>

      <div class="p2">
        参考解析：
        <div class="resolve">
          <p v-html="analysisDatas.analysis"></p>

          <!-- 答案解析图片 -->
          <el-image
            v-if="analysisDatas.analyze_thumb"
            class="mat20"
            style="width: 100px; color: #fff"
            fit="contain"
            :src="analysisDatas.analyze_thumb"
            :preview-src-list="[analysisDatas.analyze_thumb]"
          />
        </div>
      </div>
    </div>
    <div class="note-box" v-if="showNotes">
      <div class="note-list" v-if="analysisDatas.note && analysisDatas.note.length > 0">
        <el-timeline :reverse="true">
          <el-timeline-item
            v-for="(activity, index) in analysisDatas.note"
            :key="index"
            type="primary"
            icon="el-icon-time"
            size="large"
            placement="top"
            :timestamp="activity.created_at"
          >
            <div style="display: flex;justify-content: space-between;align-items: center">
              {{ activity.content }}
              <div class="submit">
                <div @click="getDataDle(index)">删除笔记</div>
              </div>
            </div>

          </el-timeline-item
          >
        </el-timeline>
      </div>
    </div>
    <!-- 纠错弹框 -->
    <ComponentCorrect
      :topicId="analysisDatas.id"
      :visible.sync="correctVisible"
    />
  </div>
</template>

<script>
import ComponentCorrect from "@/components/componentCorrect.vue";
import {qnoteDel} from "@/api/record";
export default {
  name: "QuestionAnalysis",
  components: {
    ComponentCorrect,
  },
  props: {
    analysisDatas: {
      type: Object,
      default: () => {
        return {};
      },
    },
    showNotes: {
      type: Boolean,
      default: false
    },
    isCollect: {
      is_true: Boolean
    },
  },
  filters: {
    getCorrect(item) {
      console.log(11111111111)
      console.log(item)
      if (item.correct_item) {
        let correct_item = JSON.parse(item.correct_item);

        switch (item.question_style) {
          case 4: //填空题
            return correct_item.map((item) => item.value);
          case 2: //判断题
            let mapInfo = ["A", "B", "c"];
            let inx = correct_item.key - 1;
            return mapInfo[inx];
          case 5: //简答题
            return item.correct_item;
          default:
            //单选题、多选题
            let answer = correct_item.map((item) => item.option);
            return answer.join(",");
        }
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      correctVisible: false,
    };
  },
  mounted() {},
  methods: {
    async getDataDle(index) {
      console.log(this.analysisDatas.note[index]);

      if(this.isCollect){
        qnoteDel({"id":this.analysisDatas.note[index].id});
        this.analysisDatas.note.splice(index,1)
      }else{
        this.$emit('delNote', this.analysisDatas.note[index].id);
      }
    },
  },
};
</script>
<style lang="scss">
.uni-question-analysis {
  .el-timeline,
  .el-timeline-item__timestamp {
    font-size: inherit;
  }
}
</style>
<style lang="scss" scoped>
.note-box {
  .submit {
    div {
      @include uni-button;
      @include bgColor("primary");
    }
  }
  .my-note {
    display: flex;

    .textarea-box {
      height: 0;
      overflow: hidden;
      display: flex;
      align-items: flex-end;
      transition: all 0.3s ease-in-out;

      &.active {
        height: fit-content;
        margin-top: 20px;
      }

      .input {
        width: 650px;
      }
    }
  }

  .note-list {
    margin-top: 20px;
    flex: 1;
    padding: 20px 70px;
    background: $grayBgLight;
  }
}
.note-btn {
  width: 90px;
  height: 32px;
  padding: 0 3px;
}
.uni-question-analysis {
  .scorePoints {
    width: 100%;
    background-color: #f8f8f8;
    margin-bottom: 40px;
    border-radius: 6px;
    .score {
      width: 100%;
      height: 60px;
      display: flex;
      padding: 0 20px;
      @include fontColor("primary");
      border-bottom: 1px solid $grayBorder;
      font-size: 16px;
      align-items: center;
    }
    .scorePointsList {
      width: 100%;
      padding: 20px;
      h3 {
        color: #333;
        font-size: 16px;
      }
      ul li {
        .scoreCenter {
          margin-top: 10px;
          display: flex;
          p {
            height: 100%;
            em {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #333;
              display: inline-block;
            }
          }
        }
        .scoreDf {
          @include fontColor("primary");
          margin-top: 10px;
        }
      }
    }
  }
  .answer-box {
    width: 100%;
    padding-left: 30px;
    margin-top: 20px;
    height: 0;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    border-top: 0 solid $grayBorder;

    &.active {
      height: fit-content;
      padding-top: 26px;
      padding-bottom: 26px;
      border-top-width: 1px;
    }

    .yes {
      color: $green;
      padding-left: 5px;
    }

    .p1 {
      display: flex;
      justify-content: space-between;

      .opera {
        cursor: pointer;
        margin-left: 10px;
      }
    }

    .p2 {
      display: flex;
      color: $grayLight;
      margin-top: 25px;

      .resolve {
        flex: 1 1 auto;
        padding-left: 5px;
      }
    }

    .note-box {
      margin-top: 25px;

      .my-note {
        display: flex;

        .textarea-box {
          height: 0;
          overflow: hidden;
          display: flex;
          align-items: flex-end;
          transition: all 0.3s ease-in-out;

          &.active {
            height: fit-content;
            margin-top: 20px;
          }

          .input {
            width: 650px;
          }
        }
      }

      .note-list {
        flex: 1 1 auto;
        padding: 20px;
        margin-left: 10px;
        background: $grayBgLight;
      }
    }
    .note-btn {
      width: 90px;
      height: 32px;
      padding: 0 3px;
    }
  }
}
</style>
